module.exports = __webpack_public_path__ + "static/img/2.6483539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/eqplay/imgs/swiper/2.jpg
// module id = izxj
// module chunks = 1